<div class="row">
  <h2 class="col-12"><i class="fas fa-envelope"></i> Email Templates</h2>
</div>

<div class="d-inline-flex flex-column">
  <button
    *ngIf="hasCanWriteEmailTemplate$ | async"
    class="btn btn-success"
    (click)="openCopyTemplateModal()"
  >
    <i class="fas fa-copy"></i> Copy email template(s) between accounts
  </button>

  <ng-container *ngIf="hasCanWriteEmailBootstrap$ | async">
    <button class="btn btn-success" (click)="openReBootstrapTemplatesModal()">
      <i class="fas fa-history"></i> Re-create email templates on a single
      account
    </button>

    <!-- <button
      class="btn btn-success"
      [disabled]="!(hasWawRole$ | async)"
      [ngbTooltip]="
        !(hasWawRole$ | async)
          ? 'Waw role in Back Office is required to use this feature'
          : 'Affects ALL customers. Use with extreme caution.'
      "
      (click)="openReBootstrapTemplatesModal(true)"
    >
      <i class="fas fa-history"></i> Re-create email templates on ALL accounts
    </button> -->
  </ng-container>
</div>
